import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NetworkService {
  public isConnectionSlow$ = new BehaviorSubject<boolean>(false);

  constructor(private zone: NgZone) {
    this.checkConnection(); //Revisa la conexión inmediatamente cuando inicia la aplicación

    //Acceder a la "Network Information API". No es estandar en todos los navegadores, hay que checar versiones específicas
    const connection = (navigator as any).connection || (navigator as any).mozConnection || (navigator as any).webkitConnection;

    if (connection) { //Si el navegador soporta la API
      connection.addEventListener('change', () => {
        this.zone.run(() => this.checkConnection());
      });
    }
  }

  private checkConnection() {
    const connection = (navigator as any).connection;
    if (connection && connection.effectiveType) { //Obtener la conexión actual
      const slowTypes = ['slow-2g', '2g', '3g']; //Conexiones "lentas"
      this.isConnectionSlow$.next(slowTypes.includes(connection.effectiveType)); //True si lento, false si no
    }
  }
}